// extracted by mini-css-extract-plugin
module.exports = {"contacts-title":"contacts-title__2IGP2","contactsTitle":"contacts-title__2IGP2","footer-item":"footer-item__xyJVS","footerItem":"footer-item__xyJVS","item":"item__q49XC"};